import { render, staticRenderFns } from "./DisciplineWF.vue?vue&type=template&id=5492c7f3"
import script from "./DisciplineWF.vue?vue&type=script&lang=js"
export * from "./DisciplineWF.vue?vue&type=script&lang=js"
import style0 from "./DisciplineWF.vue?vue&type=style&index=0&id=5492c7f3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports